var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lamp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356.22 166.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ae100f58-6ced-4268-a957-12c07bbbf9a9{fill:#fff;fill-opacity:0.2;}.f41bb4b5-80d0-4acf-9729-b902b57fc813{fill:none;stroke:#77a1a6;stroke-width:3.32px;}.a86ff782-8d00-47d6-ac62-2e1c9db54235,.b1388ec8-8eb7-4a54-a327-dc7290c54702{fill:#77a1a6;}.b1388ec8-8eb7-4a54-a327-dc7290c54702{fill-rule:evenodd;}.b2d0bc72-96a9-4423-935a-7fe11e079f09{fill:#f2f2f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc2e1815-9cf7-447d-a9be-71f08b628204",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e78aeaf8-c3ad-4be7-a9d3-c6bdd1d7e54f",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae100f58-6ced-4268-a957-12c07bbbf9a9",
    d: "M251.48,134.87,304,32.74,289.43,12.87,0,132.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f41bb4b5-80d0-4acf-9729-b902b57fc813",
    d: "M309.27,10.36,317,2.64a3.32,3.32,0,0,1,4.7,0h0l20.54,20.55a6.64,6.64,0,0,1,1.94,4.7V164"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a86ff782-8d00-47d6-ac62-2e1c9db54235",
    d: "M355,163.58H333a1.25,1.25,0,0,0-1.24,1.25v.41a1.25,1.25,0,0,0,1.24,1.25h22a1.25,1.25,0,0,0,1.24-1.25v-.41A1.25,1.25,0,0,0,355,163.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1388ec8-8eb7-4a54-a327-dc7290c54702",
    d: "M313.91,5.83a13.72,13.72,0,0,1,0,19.39l-8.23,8.22L286.29,14.05l8.23-8.22A13.7,13.7,0,0,1,313.91,5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b2d0bc72-96a9-4423-935a-7fe11e079f09",
    d: "M294.41,25.44c5.35,5.35,10.55,8.84,11.6,7.78s-2.43-6.25-7.78-11.6-10.56-8.84-11.61-7.79S289.05,20.08,294.41,25.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.4f19b8c20d3c05262e5092bc166c4f12.svg";
export { ForwardRef as ReactComponent };